import { render, staticRenderFns } from "./DynamicListTable.vue?vue&type=template&id=5290515c&scoped=true"
import script from "./DynamicListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicListTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicListTable.vue?vue&type=style&index=0&id=5290515c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5290515c",
  null
  
)

export default component.exports